import { Component } from '@angular/core';

@Component({
  selector: 'mtm-read-all-icon',
  templateUrl: './mtm-read-all-icon.component.html',
  standalone: true,
})
export class MtmReadAllIconComponent {}
